/**
 * Export all configurations under the shared ~/config namespace
 */

export * from "./elementAttributes";
